import {
  BulkCreateCandidateFilesDocument,
  BulkCreateCandidateFilesMutation,
  BulkCreateCandidateFilesMutationVariables,
  CandidateFilesDocument,
} from 'generated/resources/graphql'
import { orderBy } from 'lodash'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  atsCandidateId: string
}

export const useCandidateFiles = ({ atsCandidateId }: Props) => {
  const { data, loading: loadingFiles } = useQuery(CandidateFilesDocument, {
    variables: { atsCandidateId },
  })

  const [bulkCreateCandidateAtsFiles, { loading: creatingFiles, client }] = useMutation(
    BulkCreateCandidateFilesDocument,
    {
      extractorFn: (data: BulkCreateCandidateFilesMutation) => data.atsMutations.bulkCreateAtsFile,
    }
  )

  const bulkCreateCandidateFiles = async (variables: BulkCreateCandidateFilesMutationVariables) => {
    const result = await bulkCreateCandidateAtsFiles({
      variables,
    })

    const handled = handleResult(result, () => undefined)

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.documents_uploaded'),
      })

      // refetching ⤵
      client.query({
        query: CandidateFilesDocument,
        variables: { atsCandidateId },
      })
    }

    return handled
  }

  const atsFiles = data?.ats.filesConnection.nodes || []

  const candidateFiles = orderBy(atsFiles, ['createdAt'], ['desc'])

  const candidateCvFiles = candidateFiles.filter((file) => file.category === 'cv')

  return {
    loadingFiles,
    creatingFiles,
    candidateFiles,
    candidateCvFiles,
    bulkCreateCandidateFiles,
  }
}
